import { render, staticRenderFns } from "./AccountDesactive.vue?vue&type=template&id=5989456d&"
import script from "./AccountDesactive.vue?vue&type=script&lang=js&"
export * from "./AccountDesactive.vue?vue&type=script&lang=js&"
import style0 from "./AccountDesactive.vue?vue&type=style&index=0&id=5989456d&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports